module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h2', [_c('span', {
    staticClass: "h2-inner"
  }, [_vm._v("Note on Coinage")])]), _vm._v(" "), _c('p', {
    staticClass: "firstInSection"
  }, [_vm._v("Twelve pence make one shilling (1S.). Twenty shillings make one pound (1£).")]), _vm._v(" "), _c('p', [_vm._v("There are also these coins: a farthing, four of which are worth one penny (1d.); a ha’penny, two of which are worth one penny; a crown, which is worth five shillings, and a half-crown (2S. 6d.); a sovereign, which is worth one pound; a guinea, which is worth twenty-one shillings (1£ 1s.).")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Quid Quincunce speciosius, qui, in quamcunque partem")]), _vm._v(" "), _c('em', [_vm._v("spectaveris, rectus est? (Quintilian)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 63
// module chunks = 0